<div class="th-table-empty">
  <mat-icon
    *ngIf="icon"
    class="th-table-empty__icon"
    [svgIcon]="icon"></mat-icon>
  <div class="th-table-empty__header">
    {{ header }}
  </div>
</div>
